import { createFileRoute } from '@tanstack/react-router';
import { PurchasePage, validateNewPurchaseSearch } from '@/components/purchases/purchase-page';

export const Route = createFileRoute('/expenses/bills/new')({
  component: New,
  validateSearch: validateNewPurchaseSearch,
});

function New() {
  const s = Route.useSearch();
  return <PurchasePage kind="bill" {...s} />;
}
